import React from "react";
import { motion } from "framer-motion";
import { FEATURES } from "@/data/content";
import { Reveal, Overline } from "./Reveal";

export const WhyVeda = () => {
  return (
    <section id="why" data-testid="why-section" className="relative py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-3xl">
          <Reveal>
            <Overline index="01">Why Veda Vitals</Overline>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="font-serif text-3xl md:text-5xl tracking-tight text-white leading-[1.1]">
              A ritual designed around <span className="gold-text">you</span> — not just a product.
            </h2>
          </Reveal>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5 auto-rows-fr">
          {FEATURES.map((f, i) => (
            <motion.div
              key={f.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: (i % 3) * 0.08, ease: [0.16, 1, 0.3, 1] }}
              whileHover={{ y: -8 }}
              data-testid={`feature-card-${i}`}
              className={`group glass rounded-2xl p-7 md:p-8 hover:border-gold/30 transition-colors duration-300 ${
                f.span || ""
              }`}
            >
              <div className="h-12 w-12 rounded-xl border border-gold/25 grid place-items-center mb-6 group-hover:bg-gold/10 transition-colors duration-300">
                <f.icon className="h-6 w-6 text-gold" strokeWidth={1.5} />
              </div>
              <h3 className="font-serif text-2xl text-white mb-2">{f.title}</h3>
              <p className="text-vmuted leading-relaxed text-[15px]">{f.body}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
